import { RefObject, useEffect } from 'react'

const useHorizontalScroll = (ref: RefObject<HTMLDivElement | HTMLUListElement>) => {
  useEffect(() => {
    const scrollContainer = ref.current

    if (!scrollContainer) return

    const handleWheel = (event: WheelEvent) => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer
      const atStart = scrollLeft === 0
      const atEnd = scrollLeft + clientWidth >= scrollWidth

      if (event.deltaY < 0 && atStart) {
        return
      } else if (event.deltaY > 0 && atEnd) {
        return
      }

      event.preventDefault()
      scrollContainer.scrollLeft += event.deltaY
    }

    const handleMouseEnter = () => {
      scrollContainer.addEventListener('wheel', handleWheel as EventListener)
    }

    const handleMouseLeave = () => {
      scrollContainer.removeEventListener('wheel', handleWheel as EventListener)
    }

    scrollContainer.addEventListener('mouseenter', handleMouseEnter)
    scrollContainer.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      scrollContainer.removeEventListener('mouseenter', handleMouseEnter)
      scrollContainer.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [])
}

export default useHorizontalScroll
